import { render, staticRenderFns } from "./WorkshopListContainer.vue?vue&type=template&id=0537772e"
import script from "./WorkshopListContainer.vue?vue&type=script&lang=js"
export * from "./WorkshopListContainer.vue?vue&type=script&lang=js"
import style0 from "./WorkshopListContainer.vue?vue&type=style&index=0&id=0537772e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports